import {defineStore} from 'pinia';
import {ModuleAccountingObject} from '../moduleConst';
import accountingObjectAPI from '@/apis/di/accountingObjectAPI';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore';
import AccountObjectType from '@/commons/wildcards/constants/AccountObjectType';
const accountingObjectStore = new BaseDictionaryStore(accountingObjectAPI);
export const useAccountingObjectStore = defineStore(ModuleAccountingObject, {
  state: () => ({
    ...accountingObjectStore.state,
    _config: {
      key: 'object_id',
      code: 'object_alias',
      name: 'object_name',
      table: 'di_accouting_object',
      quickFollow: 'active',
      moduleName: 'Đối tượng',
      defaultSort: 'object_type_id,object_alias',
    },
    moduleName: 'diAccountingObject',
  }),
  actions: {
    ...accountingObjectStore.action,
  },
  getters: {
    ...accountingObjectStore.getters,
    ...{
      /**
       * Dữ liệu Chấp hành viên
       * ntduong2 29.5.2024
       */
      executorData: function () {
        return this.items.filter(e => e.object_type_id == AccountObjectType.Bailiffs);
      },

       /**
       * Dữ liệu đt khác
       * ntduong2 29.5.2024
       */
      objectDifferentData: function () {
        return this.items.filter(e => e.object_type_id == AccountObjectType.ObjectDifferent);
      },

       /**
       * Dữ liệu ủy ban nhân dân
       * ntduong2 29.5.2024
       */
      peopleCommiteeData: function () {
        return this.items.filter(e => e.object_type_id == AccountObjectType.PeopleCommitee);
      },

       /**
       * Dữ liệu nhầ cung cấp
       * ntduong2 29.5.2024
       */
      supplierData: function () {
        return this.items.filter(e => e.object_type_id == AccountObjectType.Supplier);
      },

      /**
       * Đối tượng phải thi hành án
       * ntduong2 29.5.2024
       */
      excutionObjectData: function () {
        return this.items.filter(
          e =>
            (e.object_type_id == AccountObjectType.ExcutionObject ||
              e.object_type_id == AccountObjectType.ExcutionPeople));
      },
      /**
       * Đối tượng được thi hành án
       * ntduong2 29.5.2024
       */
      excutedObjectData: function () {
        return this.items.filter(
          e =>
            (e.object_type_id == AccountObjectType.ExcutedObject ||
              e.object_type_id == AccountObjectType.ExcutionPeople)
        );
      },
    },
  },
});
